module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_train-1b3f90b739d6fc975b0e744c61f5875a.svg";